<template>
  <BusyButton
    ref="button"
    variant="emphasis"
    expanded
    :disabled="disabled || isAnyLoading"
    :is-loading="isLoading"
    :aria-label="isLoading ? 'Adding to your bag...' : 'Add To Bag'"
    @click="promptWnmBeforeAtb(mutate)"
  >
    <slot />
  </BusyButton>
  <component :is="data?.component" v-if="data?.component" @atb-closed="onClose" />
</template>

<script setup>
import { watchEffect, watch, ref, nextTick } from 'vue';
import BusyButton from '~/modules/ui/components/BusyButton';
import { useAddToBag } from '../composables/useAddToBag';
import useWnmAtbGate from '~/modules/worry-no-more/composables/useWnmAtbGate';

const props = defineProps({
  payload: {
    /**
     * @type {import('vue').PropType<import('../types').ATBPayload>}
     */
    type: Object,
    required: true,
  },
  payloadValidator: {
    /**
     * ? That's not the best option to pass function as prop.
     * ? It's trade off between reausablity and Vue conceptions
     * @type {import('vue').PropType<import('../types').ATBPayloadValidator>}
     */
    type: Function,
    required: false,
    default: () => null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(['error', 'bag-loaded']);

const { isLoading, isAnyLoading, mutate, data, error } = useAddToBag({
  payload: () => props.payload,
  payloadValidator: props.payloadValidator,
});

const { promptWnmBeforeAtb } = useWnmAtbGate();

/**
 * @type {import('vue').Ref<InstanceType<typeof BusyButton> | null>}
 */
const button = ref(null);

const onClose = () => {
  if (data.value?.component) {
    data.value.component = null;
    nextTick(() => button.value?.$el.focus()); // Huge re-render happnes, when onClose is called.
  }
};

watchEffect(() => {
  emits('error', error.value);
});

watch(
  () => isLoading.value,
  (val) => {
    if (val) return;

    emits('bag-loaded');
  },
);

defineExpose({
  data,
  isLoading,
  onClose,
});
</script>
